module.exports = __webpack_public_path__ + "img/coin.6e37e145.svg";